import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const token = searchParams.get("token");
    const error = searchParams.get("error");
    if (token) {
      loginWithToken(token).then(() => navigate("/", { replace: true }));
    } else {
      navigate(`/login?error=${error || "ms_login_failed"}`, { replace: true });
    }
  }, [searchParams, navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback-page">
      <div className="label-caps">Signing you in...</div>
    </div>
  );
}
